import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { LibButtonModule } from '@ui-components/button/button.module';
import { LibContentLoaderModule } from '@ui-components/content-loader';
import { SharedModule } from '@ui-components/shared.module';
import { LibPreferencesModalComponent } from './preferences-modal.component';

@NgModule({
  declarations: [
    LibPreferencesModalComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    LibButtonModule,
    LibContentLoaderModule,
    MatDialogModule
  ],
  exports: [
    LibPreferencesModalComponent
  ]
})
export class LibPreferencesModalModule { }
